<template>

    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading" class="col-lg-12">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Call Out</div>

                    </div>
                    <div class="buttons--row buttons--row-2 mb-3">
                        <div class="inner-wrap">
                            <div class="search--block">
                                <button
                                    class="search--block-btn"
                                    type="submit"
                                    @click="getCallOutList"
                                >
                                    <img src="/img/svg/icons-search.svg">
                                </button>
                                <input
                                    type="search"
                                    class="search--block-txt"
                                    placeholder="Search by Name"
                                    v-model="filters.search_name"
                                    @input="handleSearch"
                                />
                            </div>
                            <div class="search--block">
                                <button
                                    class="search--block-btn"
                                    type="submit"
                                    @click="getCallOutList"
                                >
                                    <img src="/img/svg/icons-search.svg" >
                                </button>
                                <input
                                    type="search"
                                    class="search--block-txt"
                                    placeholder="Search by Property"
                                    v-model="filters.search_property"
                                    @input="handleSearch"
                                />
                            </div>
                            <div class="filter-wrap">
                                <label for="" class="reg-label mr-2">Filter:</label>
                                <div class="form-group form-group-2 mb-0">
                                    <select
                                        class="custom-select"
                                        v-model="filters.doctor_status"
                                        @change="getCallOutList"
                                    >
                                        <option value="all">All</option>
                                        <option value="excused">Excused</option>
                                        <option value="unexcused">Unexcused</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="inner-wrap">
                            <a
                                href="javascript:void(0)"
                                class="btn btn--outline-primary btn--middle"
                                @click="exportCallOuts"
                            ><img src="/img/svg/excel.svg">
                            </a>
                            <a
                                :href="`/master-admin/call-out/create?client=${clientInfo.id}`"
                                class="btn btn--outline-primary btn--middle"
                            >+ Add New</a>
                        </div>
                    </div>
                    <div class="call-nav-tabs">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    href="javascript:void(0)"
                                    :class="{ active: activeShift === 'active' }"
                                    @click="handleShifts('active')"
                                >Active Shifts</a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link blue"
                                    href="javascript:void(0)"
                                    :class="{ active: activeShift === 'inactive' }"
                                    @click="handleShifts('inactive')"
                                >Inactive Shifts</a>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade  show active">
                            <div>
                                <div class="">
                                    <div class="table-holder table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>
                                                    <a href="javascript:void(0)" @click.prevent="changeSortList('date')"> Shift Date<i class="fas fa-sort"></i></a>
                                                </th>
                                                <th>
                                                    <nobr>
                                                        Employee Name
                                                    </nobr>
                                                </th>
                                                <th class="col-min-width">Status</th>
                                                <th>
                                                    <nobr>Shift Information</nobr>
                                                </th>
                                                <th class="text-right">Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr
                                                v-for="call in callOutList"
                                                :key="call.id"
                                            >
                                                <td>
                                                    <div class="text-14 color--text-gray">
                                                        {{formatDate(call.open_shift_timestamps)}}
                                                    </div>

                                                </td>
                                                <td>
                                                    <b>{{ call.employee.name }} {{ call.employee.last_name }}</b>
                                                    <div>
                                                        ID: {{ call.employee.last_four_digits }}
                                                    </div>
                                                </td>
                                                <td>
                                                        <span :class="{'color--green': call.doctor_status === 'excused', 'color--red': call.doctor_status === 'unexcused'}">
                                                            {{ call.doctor_status }}
                                                        </span>
                                                </td>
                                                <td>
                                                    <div>
                                                        <div class="">
                                                            {{ call.client.name }}
                                                        </div>
                                                        <div class="small-text">
                                                            <span> {{calculateDate(call.open_shift_timestamps)}}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    <div class="action-block">

                                                        <div class="action-block">
                                                            <a :href="`/master-admin/call-out/${call.id}/update?client=${clientInfo.id}`" class="edit-link"><img
                                                                src="/img/svg/icons-pen.svg" alt=""></a>
                                                            <button class="delete-link"
                                                                    @click="showDeleteModal(call.id)"
                                                            ><img src="/img/svg/on.svg" alt="delete"></button>
                                                            <ActionModal confirm-text="Yes" reject-text="No"
                                                                         :modalId="getModalId(call.id)"
                                                                         @confirm="deleteCallOut(call.id)">
                                                                <template #body>
                                                                    <div class="text-center mb-4">
                                                                        <h4>
                                                                            Are you sure you want <br> to delete this
                                                                            item?
                                                                        </h4>
                                                                    </div>
                                                                </template>
                                                            </ActionModal>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        :currentPage="pagination.current_page"
                                        :lastPage="pagination.last_page"
                                        @changePage="changePage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import CallOutService from "../../../../CallOut/resources/js/services/CallOutService";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import Pagination from "../../../../../../resources/js/components/Pagination.vue";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import {createDebouncedFunction} from "../../../../../../resources/js/plugins/debounce";

export default {
    name: 'CallOut',
    props: {
        clientInfo: {
            type: Object,
            required: true,
        }
    },
    mixins: [DateConverter],
    components: {
        ActionModal,
        Pagination
    },
    data() {
        return {
            export_call_outs: [],
            activeShift: 'active',
            loading: true,
            callOutList: [],
            filters: {
                search_name: '',
                search_property: '',
                doctor_status: 'all',
                shift: 'active',
                sortBy: 'date',
                sortDir: 'asc',
                page: 1,
                client_id: this.clientInfo.id
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        changePage(newPage) {
            this.filters.page = newPage
            this.getCallOutList(this.filters)
        },
        changeSortList(field) {
            if (this.filters.sortBy === field) {
                this.filters.sortDir = this.filters.sortDir === 'asc' ? 'desc' : 'asc';
            }
            this.filters.sortBy = field

            this.getCallOutList();
        },
        async deleteCallOut(id) {
            this.callOutList = this.callOutList.filter((call) => call.id !== id)
            try {
                await CallOutService.deleteCallOut(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        async exportCallOuts() {
            this.export_call_outs = this.callOutList.map(call => (call.id))
            const dataToSend = {
                'export_call_outs': this.export_call_outs
            };
            try {
                const response =  await CallOutService.exportCallOutsData(dataToSend)
                const blob = new Blob([response.data], { type: response.data.type });
                const link = document.createElement('a');
                let today = this.getDayToday()
                link.href = URL.createObjectURL(blob);
                link.download = `call-out_${this.clientInfo.name + '_' + today}.xlsx`;
                link.click();
                URL.revokeObjectURL(link.href);

            } catch(error) {
                console.error(error)
                this.$showErrorMessage();
            }
        },
        getModalId(Id) {
            return `modalCallId-${Id}`
        },
        async getCallOutList() {
            try {
                const {data: callOuts} = await CallOutService.getCallOutInfo(this.filters)
                this.callOutList = callOuts.data
                this.pagination.current_page = callOuts.current_page
                this.pagination.last_page = callOuts.last_page
                this.loading = false
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        handleShifts(shiftType) {
            this.activeShift = shiftType;

            if (shiftType === 'active') {
                this.filters.shift = 'active'
            } else {
                this.filters.shift = 'inactive'
            }
            this.getCallOutList()

        },
        showDeleteModal(id) {
            $(`#modalCallId-${id}`).modal()
        },
    },
    mounted() {
        this.getCallOutList();
        this.delayedSearch = createDebouncedFunction(() => this.getCallOutList(), 500);
    }

}

</script>


<style scoped>

</style>
